import { useCallback, useEffect, useState } from 'react';
import { GetAdminBackupsRemoteStatusAPI } from '../../../../api/AdminAPI';

/**
 * useAdminBackupsRemote
 *
 * Hook responsável pelo status do backup fora do servidor (bucket S3 /
 * Backblaze B2) na tela Backups do Admin Geral: mesma fonte do digest diário
 * (BackupStatusReader.php), só leitura, sem ação de escrita.
 *
 * @returns {{
 *   status: Object|null,
 *   isLoading: boolean,
 *   error: string|null,
 *   refresh: Function,
 * }}
 */
function useAdminBackupsRemote() {
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStatus = useCallback(() => {
    setIsLoading(true);
    setError(null);
    GetAdminBackupsRemoteStatusAPI((response) => {
      if (!response || response.success === false) {
        setError(response?.error || 'Erro ao carregar o status do backup remoto. Tente novamente.');
        setIsLoading(false);
        return;
      }
      setStatus(response);
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return {
    status,
    isLoading,
    error,
    refresh: fetchStatus,
  };
}

export default useAdminBackupsRemote;
